import React from 'react';
import PropTypes from 'prop-types';

import "./BackButtonArrow.scss";
import arrow from '../../../assets/imgs/back-arrow.png';

const BackButtonArrow = ({ onClick }) => {
  return (
    <button className="back-button-arrow" type="button" onClick={onClick}>
      <img className="back-button-arrow__icon" src={arrow} alt='' />
      <span className="back-button-arrow__text">Back</span>
    </button>
  );
};

BackButtonArrow.propTypes = {
  onClick: PropTypes.func
};

BackButtonArrow.defaultProps = {
  onClick: ()=> {}
};

export default BackButtonArrow;